export const FETCH_REJECT_REQUEST = "FETCH_REJECT_REQUEST";
export const FETCH_REJECT_SUCCESS = "FETCH_REJECT_SUCCESS";
export const FETCH_REJECT_FAIL = "FETCH_REJECT_FAIL";

export const CREATE_REJECT_REQUEST = "CREATE_REJECT_REQUEST";
export const CREATE_REJECT_SUCCESS = "CREATE_REJECT_SUCCESS";
export const CREATE_REJECT_FAIL = "CREATE_REJECT_FAIL";

export const SHOW_REJECT_REQUEST = "SHOW_REJECT_REQUEST";
export const SHOW_REJECT_SUCCESS = "SHOW_REJECT_SUCCESS";
export const SHOW_REJECT_FAIL = "SHOW_REJECT_FAIL";

export const UPDATE_REJECT_REQUEST = "UPDATE_REJECT_REQUEST";
export const UPDATE_REJECT_SUCCESS = "UPDATE_REJECT_SUCCESS";
export const UPDATE_REJECT_FAIL = "UPDATE_REJECT_FAIL";


export const   REFUSE_REJECT_REQUEST = " REFUSE_REJECT_REQUEST";
export const   REFUSE_REJECT_SUCCESS = " REFUSE_REJECT_SUCCESS";
export const   REFUSE_REJECT_FAIL = "REFUSE_REJECT_FAIL";
